import React from "react";
import Container from "./Container";

const Search = () => {
  return (
    <div>
      <h2> Images</h2>
      <Container />
    </div>
  );
};

export default Search;